import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { SearchLineStylesApiRequest } from '../../../types/requests/line-styles/search-line-styles.request';
import { LineStyleApiModel } from '../../../types/models/line-style.model';

export const searchLineStyles = <T extends LineStyleApiModel>(params: SearchLineStylesApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/line-styles`, { params });
